import styled from "styled-components"
import { Button } from "client/components"


export const BlockTitle = styled.h3`
    font-size: 16px;
    font-family: ${(props) => props.theme.openSans};
    margin-top: 16px;
    margin-bottom: 3px;
`
export const BlockContent = styled.div`
    margin-bottom: 15px;
`
export const BlockContentRow = styled.div`
    display: flex;
`
export const BlockContentTitle = styled.div`
    font-weight: bold;
    margin-right: 10px;
    min-width: fit-content;
`
export const List = styled.div`
    display: flex;
    flex-direction: column;
`
export const ListRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 20px;
    position: relative;

    &::before {
        content: "\\2022";
        position: absolute;
        left: 5px;
        font-size: 15px;
    }
`
export const CalculateButton = styled(Button)`
    height: 24px;
    text-transform: unset;
    margin: 2px 5px;
    background: ${(props) => props.theme.silResultCalculateButtonBackground};
`
export const TabWrapper = styled.div`
    display: flex;
    flex-direction: row;
`
export const TabList = styled.div`
    display: flex;
    flex-direction: column;
    width: 170px;
`
export const TabListRow = styled.div<{
    active: boolean
}>`
    padding: 10px 15px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    background: ${(props) => (props.active ? props.theme.silResultTabBackgroundActive : props.theme.silResultTabBackground)};

    &:hover {
        background: ${(props) => (props.active ? props.theme.silResultTabBackgroundActive : props.theme.silResultTabBackgroundHover)};
    }
`
export const TabContent = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - 170px);
    padding: 0 15px;
`
export const ResultTable = styled.table`
    width: 100%;
    white-space: pre-line;

    th, td {
        border: 1px solid ${(props) => props.theme.silResultTableBorderColor};
        padding: 8px;
    }

    th {
        background: ${(props) => props.theme.silResultTableHeaderBackground};
    }
`
export const ResultTableAnnotation = styled.div`
    width: 100%;
    text-align: center;
    padding: 8px;
`
